import { Builder } from '@builder.io/react'
import dayjs from 'dayjs'
import React from 'react'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundColor: string
  headingOne: string
  headingTwo: string
  textOne: string
  textTwo: string
  textAlignment: Alignment
  verticalPadding: boolean
  blogDate: string
  blogCategory: string
}

const BlogText = ({
  backgroundColor,
  headingOne,
  headingTwo,
  textOne,
  textTwo,
  textAlignment,
  verticalPadding,
  blogDate = '',
  blogCategory = ''
}: Props) => {
  const dateFormatted = (date: any) => {
    const dateObj = new Date(date)
    const dateStr = dayjs(dateObj).format('D MMMM YYYY')
    return dateStr
  }
  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const textAlignClass = getAlignmentClass()

  return (
    <div
      className={`bg-white rounded-2xl py-4 mx-0 ${verticalPadding ? 'my-2' : 'my-0'}`}
      style={{ backgroundColor: backgroundColor }}
    >
      {headingOne && (
        <div
          className={`${textAlignClass} ${backgroundColor ? 'px-4' : ''} ${headingTwo ? 'pb-6' : 'pb-0'} flex mx-auto items-center font-serif font-medium text-3xl`}
        >
          {headingOne}
        </div>
      )}
      {headingTwo && (
        <div
          className={`${textAlignClass} ${backgroundColor ? 'px-4' : ''} ${textOne ? 'pb-6' : 'pb-0'} flex mx-auto items-center font-sans font-semibold text-2xl`}
        >
          {headingTwo}
        </div>
      )}
      {textOne && (
        <div
          className={`${textAlignClass} ${backgroundColor ? 'px-4' : ''} ${textTwo ? 'pb-6' : 'pb-0'} flex flex-col mx-auto`}
          dangerouslySetInnerHTML={{ __html: textOne }}
        />
      )}
      {textTwo && (
        <div
          className={`${textAlignClass} ${backgroundColor ? 'px-4 text-black' : ''} flex mx-auto`}
          dangerouslySetInnerHTML={{ __html: textTwo }}
        />
      )}
      {(blogDate || blogCategory) && (
        <div
          className={`flex ${blogCategory ? 'gap-4' : ''} py-1 text-sm mx-auto h-full justify-start text-primary flex flex-row`}
        >
          {blogDate && <span>{dateFormatted(blogDate)}</span>}
          {blogDate && blogCategory && <span className="-mx-2">·</span>}
          {blogCategory && <span>{blogCategory}</span>}
        </div>
      )}
    </div>
  )
}

export default BlogText

Builder.registerComponent(BlogText, {
  name: 'BlogText',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'headingOne',
      type: 'string',
      defaultValue: ''
    },
    {
      name: 'headingTwo',
      type: 'string',
      defaultValue: ''
    },
    {
      name: 'textOne',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textTwo',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'verticalPadding',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'blogDate',
      type: 'date',
      defaultValue: ''
    },
    {
      name: 'blogCategory',
      type: 'string',
      defaultValue: ''
    }
  ]
})
